import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class TableService {
  public url: string;
  public urlUser: string;
  public token: string | null;
  public headers: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token") || "null");
    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  closeTable(json: any): Observable<any> {
    return this.petition(`${this.url}/tabladinamica/new`, json);
  }

  listTables(json: any): Observable<any> {
    return this.petition(`${this.url}/tabladinamica/list`, json);
  }

  petition(url: string, json: any = null, type: string | null = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let paramas = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      paramas = paramas + "&json=" + json;
    }

    if (type != null) {
      paramas = paramas + "&type=" + type;
    }

    return this._http
      .post(url, paramas, { headers: this.headers })
      .pipe(map((res) => res as any));
  }
}
